import { IconProps } from '../../Icon.types';

export const Training3DIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_3982_59689)">
        <path
          d="M25.4416 5.17006L44.0418 15.3695C45.0359 15.9146 45.5988 16.9404 45.6 17.9993L45.5992 18V30.6C45.5992 31.5941 44.7933 32.4 43.7992 32.4C42.8051 32.4 41.9992 31.5941 41.9992 30.6L41.9984 21.7493L38.3984 23.7221L38.3992 31.2C38.3992 37.9211 31.8782 43.2 23.9992 43.2C16.1202 43.2 9.5992 37.9211 9.5992 31.2L9.59844 23.7221L3.95658 20.6304C2.5038 19.8338 1.97189 18.0103 2.76852 16.5575C3.0433 16.0564 3.45548 15.6443 3.95658 15.3695L22.5568 5.17006C23.4553 4.67736 24.5431 4.67736 25.4416 5.17006ZM34.7984 25.6973L25.4416 30.8299C24.5431 31.3226 23.4553 31.3226 22.5568 30.8299L13.1984 25.6973L13.1992 31.2C13.1992 35.7454 17.9607 39.6 23.9992 39.6C30.0377 39.6 34.7992 35.7454 34.7992 31.2L34.7984 25.6973ZM23.9992 8.48482L6.6469 18L23.9992 27.5151L41.3515 18L23.9992 8.48482Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3982_59689"
          x="1.39844"
          y="4.80054"
          width="44.2012"
          height="39.3994"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3982_59689"
          />
        </filter>
      </defs>
    </svg>
  );
};
